import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, vModelText as _vModelText, withModifiers as _withModifiers, withKeys as _withKeys, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@assets/speaker_mute.png'
import _imports_1 from '@assets/speaker_on.png'
import _imports_2 from '@assets/emoji_nobody.png'


const _withScopeId = n => (_pushScopeId("data-v-d423ef3e"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "wrap_screen"
}
const _hoisted_2 = {
  key: 0,
  src: _imports_0
}
const _hoisted_3 = {
  key: 1,
  src: _imports_1
}
const _hoisted_4 = { class: "tabbar" }
const _hoisted_5 = { class: "other_profile" }
const _hoisted_6 = ["src"]
const _hoisted_7 = {
  key: 1,
  class: "other_picture",
  src: _imports_2
}
const _hoisted_8 = { class: "other_profile_info" }
const _hoisted_9 = { class: "wrap_chat_screen" }
const _hoisted_10 = { class: "room_info" }
const _hoisted_11 = { class: "wrap_input_screen" }
const _hoisted_12 = { class: "wrap_input" }
const _hoisted_13 = ["onKeypress"]
const _hoisted_14 = {
  key: 1,
  class: "wrap_screen"
}
const _hoisted_15 = { class: "tabbar" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "other_profile" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "other_profile_info" })
], -1))
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "wrap_waiting_screen" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "room_info" }, [
    /*#__PURE__*/_createElementVNode("div", null, "메세지를 보내려면 채팅을 선택하세요.")
  ])
], -1))

import { useRoute } from 'vue-router';
import {
  ref,
  computed,
  watch,
  onMounted,
} from 'vue';
import { useWebSocketStore } from '../stores/storeWebSocket';
import { useSpeechRecognitionStore } from '../stores/storeSpeechRecognition';
import {
  tabStore,
  userStore,
  tutorialStore,
} from '../stores/storeAuth';
import { useAudioStore } from '../stores/storeAudio';
import { pushPage } from '@utils/route.helper';
import { errorType } from '@interface/error';
import { postSpeakerUser } from '@apis/voicechat';
import { postStreams } from '@apis/streams';


export default /*#__PURE__*/_defineComponent({
  __name: 'ChatUser',
  setup(__props) {

const tabData = tabStore();
const showMobileMenu = () => {
  tabData.sideMenu = true;
};

// eslint-disable-next-line camelcase, arrow-body-style
const isAnimal = (profileUrl: string, animals: string[]) => {
  return profileUrl && animals.some((animal) => profileUrl.includes(animal));
};

const isMute = ref(false);
const turnMute = () => {
  isMute.value = !isMute.value;
};
const chatScreenRef = ref<HTMLElement | null>(null);
const scrollToBottom = () => {
  if (chatScreenRef.value) {
    chatScreenRef.value.scrollTop = chatScreenRef.value.scrollHeight;
  }
};
const client = useWebSocketStore();
const route = useRoute();
const roomId: string = route.query.id as string;
console.log('chatUser에 접속한 roomId(query string):', roomId);

// const otherMessage = ref('응! 알겠어~');
const messages = computed(() => client.roomMessageList[client.currentRoomInfo.roomId]);
const myUserId = computed(() => client.sender);
const currentRoomInfo = computed(() => client.currentRoomInfo);
const newMessage = ref<string>('');
const isSpeaking = ref(true);
const speakerBase64Result = ref('');

// speaker user
const speakerUser = async (base64Data: string) => {
  const params = { audio_base64_string: base64Data };
  try {
    const result = await postSpeakerUser(params);
    console.log(result.data.speaker_base64_string, '💛💛');
    speakerBase64Result.value = result.data.speaker_base64_string;
  } catch (error) {
    alert(error);
  }
};

// 메시지 보냄
const sendMessage = () => {
  console.log('sending messages', newMessage.value);
  console.log('currentRoomInfo', currentRoomInfo.value, 'gogogogogogo');
  if (!currentRoomInfo.value.isActive) {
    console.log('room is not active ', messages.value);
    return;
  }
  // console.log('message list', messages.value);
  const chat = newMessage.value.trim();
  console.log('chat', chat);
  newMessage.value = '';
  if (chat !== '') {
    client.sendToken({
      event: 'SEND_CHAT',
      roomId: currentRoomInfo.value.roomId,
      data: { chat },
    });

    setTimeout(() => {
      scrollToBottom();
    }, 600);
  }
};

const handleEnterKey = () => {
  sendMessage();
  newMessage.value = '';
};

const handleShiftEnterKey = (event: any) => {
  if (event.shiftKey) {
    // 쉬프트 키를 누르면서 엔터 키를 눌렀을 때
    newMessage.value += '\n'; // 또는 다른 줄바꿈 처리 방법을 사용할 수 있습니다.
  } else {
    // 쉬프트 키 없이 엔터 키만 눌렀을 때
    handleEnterKey();
  }
};

// SECTION -  ChatUser:STT
const speechRecognitionStore = useSpeechRecognitionStore();
const handleSpeechResult = (spokenText: string | null) => {
  if (spokenText) {
    newMessage.value = spokenText;
    sendMessage();
  }
};
const startSpeechListening = () => {
  speechRecognitionStore.startSpeechRecognition(handleSpeechResult);
};
const stopSpeechListening = () => {
  speechRecognitionStore.stopSpeechRecognition();
};
const isListening = computed(() => speechRecognitionStore.isListening);
// !SECTION - ChatUser:STT

// SECTION - ChatUser:TTS
const streamUser = async (quest: string, sender: string) => {
  const params = {
    quest,
    user_id: sender,
  };
  try {
    const audioStore = useAudioStore();
    console.log('call streamUser', '🩷🩷');
    postStreams('user', params.quest, params.user_id);
  } catch (error) {
    console.log(error);
  }
};

watch(
  () => client.currentRoomLastChat,
  (newValue, oldValue) => {
    console.log('watch :', newValue, oldValue);
    // 속성 값이 변경될 때 실행되는 로직
    if (isSpeaking.value && newValue && !isMute.value) {
      console.log('[quest] :', newValue, '[isSpeaking]:', isSpeaking.value);
      streamUser(newValue, client.currentRoomInfo.userId);
    }
  },
);
// !SECTION - ChatUser:TTS

return (_ctx: any,_cache: any) => {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (currentRoomInfo.value.userId !== '')
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", {
          class: "mute",
          onClick: turnMute
        }, [
          (isMute.value)
            ? (_openBlock(), _createElementBlock("img", _hoisted_2))
            : (_openBlock(), _createElementBlock("img", _hoisted_3))
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_font_awesome_icon, {
            class: "chevron",
            icon: "fa-solid fa-bars",
            onClick: showMobileMenu
          }),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", null, [
              (isAnimal(currentRoomInfo.value.profileUrl, ['fox', 'shark', 'tiger', 'koala', 'bear', 'unicorn', 'lion', 'dog']))
                ? (_openBlock(), _createElementBlock("img", {
                    key: 0,
                    class: "other_picture",
                    src: require(`@assets/${currentRoomInfo.value.profileUrl}`),
                    alt: "Profile Picture"
                  }, null, 8, _hoisted_6))
                : (_openBlock(), _createElementBlock("img", _hoisted_7))
            ]),
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", null, _toDisplayString(currentRoomInfo.value.nickName), 1)
            ])
          ])
        ]),
        _createElementVNode("div", {
          ref_key: "chatScreenRef",
          ref: chatScreenRef,
          class: "scroll"
        }, [
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("div", null, _toDisplayString(currentRoomInfo.value.nickName) + "와 대화를 시작해보세요", 1)
            ]),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(messages.value, (message, index) => {
              return (_openBlock(), _createElementBlock("div", {
                key: index,
                class: _normalizeClass({
            'bubble': true,
            'other_bubble': message.sender !== myUserId.value,
            'my_bubble': message.sender === myUserId.value
          })
              }, _toDisplayString(message.chat), 3))
            }), 128))
          ])
        ], 512),
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("div", _hoisted_12, [
            _withDirectives(_createElementVNode("textarea", {
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((newMessage).value = $event)),
              class: "input",
              placeholder: "Message",
              onKeypress: _withKeys(_withModifiers(handleShiftEnterKey, ["exact","prevent"]), ["enter"])
            }, null, 40, _hoisted_13), [
              [_vModelText, newMessage.value]
            ]),
            (!isListening.value)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  class: "button_rec",
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (startSpeechListening()))
                }, [
                  _createVNode(_component_font_awesome_icon, { icon: "fa-solid fa-microphone" })
                ]))
              : _createCommentVNode("", true),
            (isListening.value)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 1,
                  class: "button_rec",
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (stopSpeechListening()))
                }, [
                  _createVNode(_component_font_awesome_icon, { icon: "fa-solid fa-square" })
                ]))
              : _createCommentVNode("", true)
          ])
        ])
      ]))
    : (_openBlock(), _createElementBlock("div", _hoisted_14, [
        _createElementVNode("div", _hoisted_15, [
          _hoisted_16,
          _createVNode(_component_font_awesome_icon, {
            class: "chevron",
            icon: "fa-solid fa-bars",
            onClick: showMobileMenu
          })
        ]),
        _hoisted_17
      ]))
}
}

})